export default "__VITE_ASSET__KFGjLuOr__"